import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./styles/global.css";

import AppLayout from "./components/AppLayout";
import LoginPage from "./pages/LoginPage";
import CreateAccount from "./pages/CreateAccount";
import CapitalLogin from "./pages/CapitalLogin";
import Dashboard from "./pages/Dashboard";
import SalePoint from "./pages/SalePoint";
import RateWorkPage from "./pages/RateWorkPage";
import DailyReports from "./pages/DailyReports";
import CustomerManager from "./pages/CustomerManager";
import CustomerLedger from "./pages/CustomerLedger";
import Inventory from "./pages/Inventory";
import Capital from "./pages/Capital";
import GoldTestingReport from "./pages/GoldTestingReport";
import GoldTestReportPage from "./pages/GoldTestReportPage";
import ReceiptBySerial from "./pages/Receipt";
import PendingTransactions from "./pages/PostDateWork";
import SilverRateWork from "./pages/SilverRateWorkPage";
import CustomerAduit from "./pages/CustomerAudit";
import BrandSettings from "./pages/BrandSetting";
import WhatsAppReportTable from "./components/whatsapp/WhatsappReportTable";
import AddInventoryPage from "./pages/AddInventory";

function PrivateRoute({ children }) {
  const loggedIn = localStorage.getItem("token");
  console.log("PrivateRoute - loggedIn:", loggedIn);
  return loggedIn ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Auth routes (no layout) */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/customeraudit/:customerId" element={<CustomerAduit />} />
        <Route path="/register" element={<CreateAccount />} />
        <Route path="/capital-login" element={<CapitalLogin />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route
          path="/salepoint/gold-test-report"
          element={<GoldTestReportPage />}
        />

        {/* Authenticated routes (with sidebar layout) */}
        <Route
          element={
            <PrivateRoute>
              <AppLayout />
            </PrivateRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/salepoint" element={<SalePoint />} />
          <Route
            path="/gold-rate-work"
            element={<RateWorkPage headerLabel="Gold" key={"gold"} />}
          />
          <Route
            path="/silver-rate-work"
            element={<RateWorkPage headerLabel="Silver" key={"silver"} />}
          />
          <Route path="/daily-reports" element={<DailyReports />} />
          <Route path="/customer-manager" element={<CustomerManager />} />
          <Route path="/customer-ledger/:id" element={<CustomerLedger />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/openinginventory" element={<AddInventoryPage />} />
          <Route path="/capital" element={<Capital />} />
          <Route path="/report" element={<GoldTestingReport />} />
          <Route path="/receipt" element={<ReceiptBySerial />} />
          <Route path="/postdatework" element={<PendingTransactions />} />
          <Route path="/user-preference" element={<BrandSettings />} />
          <Route path="/whatsappreport" element={<WhatsAppReportTable />} />
          <Route path="/help-center" element={<h1>Not found</h1>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
